import { BrowserRouter } from "react-router-dom";
import Routes from "routes/routes";
import { AuthContextProvider } from "contexts/AuthContextProvider";
import { ClientContextProvider, client } from "utils/ApiUtils";

const App = () => {
  return (
    <BrowserRouter>
      <ClientContextProvider client={client}>
        <AuthContextProvider>
          <Routes />
        </AuthContextProvider>
      </ClientContextProvider>
    </BrowserRouter>
  );
};

export default App;
